export const dashboardPaths = {
  absolute: '/:clientId/dashboards',

  fullDashboard: {
    absolute: '/:clientId/dashboards/:dashboardId',
    relative: ':dashboardId',
  },
} as const;

export const executiveSummaryPaths = {
  absolute: '/:clientId/executive-summary',
} as const;
